/* eslint-disable no-unused-vars */
/* eslint-disable no-loop-func */
import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getTransactionsList, getAccountData, setAtAuth} from "../redux/actions";
import TransactionsTable from "./Components/TransactionsTable";
import "./index.scss";
import ConnectSvg from "./RadiusConnectSvg";
import PaypalButtonsServer from "./Components/PaypalButtonsServer";
import {InfoCircleOutlined} from '@ant-design/icons';
import {useHistory} from "react-router-dom";
import {calcBalanceHelper, trafficBalHelper} from "../Components/helpers";
import moment from "moment";
import { Breadcrumb, Typography, Divider, Button, Modal, Input } from 'antd';
import { useCookies } from 'react-cookie';
import { Link } from "@mui/material";
import mpesaPng from "../img/mpesa.png";
import axios from 'axios';
import { apiHost } from "../redux/util/config";
import { confirm as paymentComplete } from "../Components/Confirm/confirm";


const { Title, Text } = Typography;
const { confirm } = Modal;


function NonPayedBlock() {
  const history = useHistory();
  return (
    <div className="non-payed">
      <InfoCircleOutlined style={{ fontSize: 20 }}/><p>Your Billing Plan is not active! Click <Link onClick={() => history.push("/billingplan")}>HERE</Link> to go to billing plans and choose a plan!</p>
    </div>
  )
}
export default function MainPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { item: accountData } = useSelector(({account}) => account);
  const { username, password } = useSelector(({account}) => account);
  const { loginUrl } = useSelector(({account}) => account);
  const [ cookies, setCookie ] = useCookies(['user'])
  const [ connectData, setConnectData ] = useState(false);
  const { items: transactions } = useSelector(({transaction}) => transaction);
  const [ visible, setVisible ] = useState(false);
  const [ phoneNo, setPhoneNo ] = useState('');

  useEffect(() => {
    dispatch(getTransactionsList())
  }, [dispatch]);

  useEffect(() => {
    console.log('accountData.status: ', accountData);
    const link = `${loginUrl}?username=${username}&password=${password}`;
    if (accountData && accountData.status && accountData.status === 'ACTIVE') {
      console.log('auto login by redirecting to ', link);
      window.location.href = link;
    }
  }, [accountData, username, password, loginUrl]);

  const checkIsActiveBillingPlan = () => {
    const bool = accountData.billings && accountData.billings.length !== 0;
    // console.log("checkIsActiveBillingPlan: ", bool);
    return !bool;
  }

  const payWithMpesa = () => {
    // console.log('mobile phone number: ', accountData.mobilePhone);
    if(accountData.mobilePhone) {
      createMpesaOrder();
    } else {
      setVisible(true);
    }
  }

  const billingPlanItems = () => {
    let data = accountData.billings;
    if (accountData.billings.length === 2 && accountData.billings[0].billingPlanId === accountData.billings[1].billingPlanId) {
      data = [accountData.billings[0]];
    }
    if (data.length > 0) {
      return (
        data.sort((a, b) => a.id > b.id ? 1 : -1).map((item) => {
          let cData = 0;
          if (item.billingPlanTypeId === 1 && item.currentData > 0) {
            if (item.currBP.billingUnit === "Gb") cData = (item.currentData / 1024 / 1024 / 1024).toFixed(2);
            if (item.currBP.billingUnit === "Mb") cData = (item.currentData / 1024 / 1024).toFixed(2);
          }
          return (
            <div className="main-page-block" key={item.id}>
              <h3 className="plan-heading">
                {item.billingPlanId === accountData.billingPlanId ? "Current Billing Plan" : "Next Billing Plan"}
              </h3>
              <div className="current-plan-item">
                <h3 className="cost-amnt margin10">${item.currBP.cost}<span>/mo.</span></h3>
                <p className="plan-name margin10">
                  {item.currBP.name}
                </p>
                <div className="plan-dets">
                  {(item.billingPlanTypeId === 1) && (
                    <p>Data limit: <span
                      className="value">{item.currBP.dataLimit} {item.currBP.billingUnit}</span>
                    </p>
                  )}
                  {(item.billingPlanTypeId === 2) && (
                    <p>Time limit: <span
                      className="value">{item.currBP.timeLimit} {item.currBP.billingUnit}</span>
                    </p>
                  )}
                  <p>Bandwidth Up: <span className="value">{item.currBP.planBandwidthUp}mbps</span></p>
                  <p>Bandwidth Down: <span className="value">{item.currBP.planBandwidthDown}mbps</span></p>
                  {item.currBP.specOffers && item.currBP.specOffers !== "" && (
                    <p>Special Offer: <span className="value">{item.currBP.specOffers}</span></p>
                  )}
                  {(item.billingPlanTypeId === 2 && item.dateFrom && item.dateTo) && (
                    <p>Dates: <span
                      className="value">{moment(item.dateFrom).format("YYYY-MM-DD")} - {moment(item.dateTo).format("YYYY-MM-DD")}</span>
                    </p>
                  )}
                  {/*item.billingPlanTypeId === 1 && (
                    <p>Remaining traffic: <span
                      className="value">{cData} {item.currBP.billingUnit}</span>
                    </p>
                  )*/}
                  {item.isPayed === false && (
                    <>
                      <Button className="change-paln-btn" variant={"contained"}
                              onClick={() => history.push("/billingplan")}>Change Plan</Button>
                      <br/>
                      <Button 
                        type="primary"
                        color="green"
                        size="large"
                        shape="round"
                        onClick={payWithMpesa}
                        style={{ marginBottom: 10, background: "#72ae43", width: "100%", fontWeight: "bold" }}
                      >
                        <span><img alt="mpesa logo" src={mpesaPng} width={40} style={{ marginTop: 7 }}/></span>
                        Pay with Mpesa
                      </Button>
                      <br/>
                      <PaypalButtonsServer/>
                    </>
                  )}
                </div>
              </div>
            </div>
          )
        })
      )
    } else if (accountData.currBP) {
      const { currBP } = accountData;
      return (
        <div className="main-page-block">
          <h3 className="plan-heading">Current Billing Plan</h3>
          <div className="current-plan-item">
            <h3 className="cost-amnt">${currBP.cost}<span>/mo.</span></h3>
            <p className="plan-name">{currBP.name}</p>
            <p>Billing Unit: <span className="value">{currBP.billingUnit}</span></p>
            {currBP.billingPlanId === 1 && (
              <p>Limit: <span className="value">{currBP.dataLimit} {currBP.billingUnit}</span></p>
            )}
            {currBP.billingPlanId === 2 && (
              <p>Limit: <span className="value">{currBP.timeLimit} {currBP.billingUnit}</span></p>
            )}
            <p>Bandwidth Up: <span className="value">{currBP.planBandwidthUp}mbps</span></p>
            <p>Bandwidth Down: <span className="value">{currBP.planBandwidthDown}mbps</span></p>
            {currBP.specOffers && currBP.specOffers !== "" && (
              <p>Special Offer: <span className="value">{currBP.specOffers}</span></p>
            )}
            <Button 
              type="primary" 
              size="large" 
              className="change-paln-btn"
              onClick={() => history.push("/billingplan")}
            >
              Change Plan
            </Button>
            <br/>
            <Button color="green" variant="solid">Pay with MPesa</Button>
            <br/>
            <PaypalButtonsServer/>
          </div>
        </div>
      )
    }
  }
  
  const connectSubmit = async e => {
    e.preventDefault();
    dispatch(setAtAuth(false));
    setCookie('user', null, { path: '/' });
    const form = document.getElementById('form');
    form.submit();
    // alert(`username: ${username}, password: ${password}`);
    // window.location.href = `http://captive.portal4/www/login.chi?username=${username}&password=${password}`;
  }

  const credit = accountData && accountData.status && accountData.status === 'ACTIVE' ? true : false;
  // console.log("accountData: ", accountData);

  const createMpesaOrder = () => {
    setVisible(false);
    // console.log('phone no. from input: ', phoneNo);
    const pattern = /((254|0)7[0-9]{8})|((254|0)(11|10)[0-9]{7})/;
    // console.log("pattern: ", pattern.test(phoneNo));
    let error = false; let msg = '';
    if(phoneNo === '') {
      msg = 'Error! No phone number provided!';
      error = true;
    } else if(!pattern.test(phoneNo)) {
      msg = 'Error! Wrong phone number format!';
      error = true;
    }

    if(error) {
      Modal.error({
        title: 'Phone Number Error',
        content: msg,
      });
    } else {
      // send phone number and create mpesa order...
      axios.post(
        `${apiHost}/api/mpesaOrder`, 
        { phoneNumber: phoneNo }, 
        { withCredentials: true }
      ).then(res => {
        // console.log('create new mpesa order res: ', res.data.CheckoutRequestID);
        confirm({
          title: 'Confirm Payment',
          content: "A payment request has just been sent to your phone. Please enter your pin to confirm payment on your phone then come back here and click on the 'Confirm' button",
          okText: 'Confirm',
          onOk() {
            // console.log('OK');
            checkMpesaPayment(res.data.CheckoutRequestID);
          },
          onCancel() {
            // console.log('Cancel');
            checkMpesaPayment(res.data.CheckoutRequestID);
          },
        });
      }).catch(err => {
        console.log('create mpesa order error: ', err);
      });
    }
  }

  const checkMpesaPayment = requestId => {
    axios.post(
      `${apiHost}/api/mpesaOrder/capture`, 
      { CheckoutRequestID: requestId},
      { withCredentials: true }
    ).then(res => {
      // console.log("capture mpesa payment res: ", res.data);
      if(res.data.status === "success") {
        dispatch(getTransactionsList());
        dispatch(getAccountData());
        paymentComplete({
          confirmActionText: "Ok", // optional
          confirmAction: () => {}, // optional
          cancelAction: () => {}, // optional
          text: "🙂.Mpesa payment completed successfully!", // optional
        });
      } else {
        Modal.error({
          title: 'Mpesa Payment Error',
          content: 'Sorry! Something went wrong with the payment! You might have cancelled it on your phone! Please try again later.',
        });
      }
    }).catch(err => console.log("capture mpesa payment error: ", err));
  }

  return (
    <div>
      <Breadcrumb
        style={{
          marginTop: 20,
          fontSize: '1rem',
        }}
        items={[
          {
            title: 'Dashboard',
          },
          {
            title: 'Home',
          },
        ]}
      />
      {accountData && (
        <>
          <div>
            <Title level={2} style={{ marginBottom: 5 }}>Dashboard</Title>
            <Text type="secondary" style={{ fontSize: 16 }}>
              View your current billing plan's bandwidth and data usage limits as well as the remaining bandwidth. Checkout all your payments below.
            </Text>
          </div>
          <Divider />
          {checkIsActiveBillingPlan() && <NonPayedBlock />}
          <div className="main-page-blocks-wrapper">
            {/*{getCurrentBP()}*/}
            {/*{getNextBP()}*/}
            {billingPlanItems()}
            {/* {accountData.currBP && accountData.billings.length > 0 && accountData.billings.filter(({isPayed}) => isPayed === true).length < 2 && (
              <div className="main-page-block">
                <h3>Pay ${getPayCost(accountData.billings)} now</h3>
                <PaypalButtonsServer />
              </div>
            )} */}
            <div className="main-page-block">
              <h3 
                className="plan-heading" 
                style={{ background: 'linear-gradient(135deg, #6253e1, #04befe)'}}
                >My Balance</h3>
              <h3 className="cost-amnt">${calcBalanceHelper(accountData)}</h3>
              <p className="plan-name margin10">Current Remaining Balance</p>
              <Divider style={{ marginBottom: 5 }} />
              <h3 className="cost-amnt">{trafficBalHelper(accountData)}</h3>
              <p className="plan-name" style={{ marginBottom: 36 }}>Current remaining bandwidth</p>
              {/*<div>Date till: 12.03.2022</div>*/}
            </div>
            <div className={ credit ? "main-page-block" : "main-page-block disabled-block"}>
            {/* <div className="main-page-block"> */}
              <h3 className="plan-heading">Connect to Radius server</h3>
              {!connectData ? (
                <div className="pfont">
                  <h3>Click below button to login to Wifi!</h3>
                  <p>You can login into the Wifi Network after payment by logging into the Radius Server using the button below.</p>
                  <form id="form" name="form" method="post" action={loginUrl}>
                    <input type="hidden" name="userurl" value="https://google.com" required />
                    <input name="username" value={username} type="hidden" />
                    <input name="password" value={password} type="hidden" />
                    <input type="button" onClick={connectSubmit} disabled={!credit} className="wifi-login" name="button" value="Connect" />
                  </form>
                </div>
              ) : (
                <div>
                  <ConnectSvg />
                  <p className="connected">Connected</p>
                </div>
              )}
            </div>
          </div>


      </>
      )}
      { transactions && accountData && (
        <div className="main-transactions-block">
          <div className="transactions-block-table" style={{width: "100%", marginRight: "20px"}}>
            <h2 style={{ marginTop: "unset"}}>Last Payments</h2>
            <TransactionsTable items={transactions.length > 3 ? transactions.slice(0,3) : transactions} />
          </div>
        </div>
      )}
      <Modal
          title="Pay With Mpesa"
          visible={visible}
          onOk={createMpesaOrder}
          onCancel={() => setVisible(false)}
          footer={[
            <Button key="back" onClick={() => setVisible(false)}>
              Cancel
            </Button>,
            <Button 
              key="submit" 
              type="primary" 
              onClick={createMpesaOrder}
              style={{ background: "#72ae43", fontWeight: "bold" }}>
              Pay
            </Button>,
          ]}
      >
        <Input placeholder="Enter your phone number:" value={phoneNo} onChange={(e) => setPhoneNo(e.target.value)}/>
        <p>We will send an Mpesa payment request to this phone number via STK push.</p>
      </Modal>
    </div>
  )
}